import { useEffect, useRef } from 'react'
import headlessToast, { toast } from 'react-hot-toast/headless'
import { StandardToast } from '@components/Notifications/StandardToast'

import { useLiveClientError } from './LiveClientProvider'

/**
 * Component that listens to LiveClient errors and displays toast notifications.
 * This should be rendered inside the LiveClientProvider.
 */
export function LiveClientErrorToast() {
    const error = useLiveClientError()
    const toastIdRef = useRef<string | undefined>(undefined)

    useEffect(() => {
        const dismissToast = () => {
            if (toastIdRef.current) {
                headlessToast.dismiss(toastIdRef.current)
                toastIdRef.current = undefined
            }
        }

        if (error) {
            const { code, message } = error
            const errorMessage = `${code}: ${message}`
            console.error('[LiveClient] Error:', errorMessage)

            // Dismiss any existing toast before showing new one
            dismissToast()

            toastIdRef.current = toast.custom(
                (t) => (
                    <StandardToast.Error
                        toast={t}
                        message="Live connection error"
                        subMessage={errorMessage}
                    />
                ),
                {
                    duration: 10000, // Auto-dismiss after 10 seconds
                },
            )
        } else {
            dismissToast()
        }

        return () => {
            dismissToast()
        }
    }, [error])

    return null
}
